import React from 'react';
import { Link } from 'react-router-dom';
import { getUpcomingCreators } from '../../utils/catalog';
import { daysUntilStart, formatDate } from '../../utils/exhibition';
import { NewsletterForm } from '../ui/NewsletterForm';
export function UpcomingCreators() {
  const upcoming = getUpcomingCreators();
  return <section className="mx-auto max-w-[1440px] px-5 md:px-8" aria-labelledby="bientot-title" data-id="element-350" data-mp="3e2qs5tex9p9h">
      <div className="grid gap-10 rounded-sm bg-card px-6 py-12 md:px-12 md:py-16 lg:grid-cols-12 lg:gap-16" data-id="element-351" data-mp="302zg3y7yuiy4">
        <div className="lg:col-span-5" data-id="element-352" data-mp="353wvy45i70wg">
          <h2 id="bientot-title" className="font-display text-4xl leading-[1.02] md:text-5xl" data-id="element-353" data-mp="350r9yxs68f4y">
            Bientôt <em className="text-sage" data-id="element-354" data-mp="2v4xy7gma0po8">en vitrine</em>
          </h2>
          <p className="mt-4 max-w-sm text-muted" data-id="element-355" data-mp="2v5g0atvmdy42">
            Recevez un mot le jour de leur arrivée — les premières pièces partent souvent dans la semaine.
          </p>
          <div className="mt-8 max-w-sm" data-id="element-356" data-mp="tcjimo77fxaz">
            <NewsletterForm cta="Me prévenir" data-id="element-357" data-mp="tbgrcf5yzsuj" />
          </div>
        </div>
        <ul className="divide-y divide-line lg:col-span-7" data-id="element-358" data-mp="22yr4d5hnuljs">
          {upcoming.map(c => <li key={c.id} data-id="element-359" data-mp="1y0pn8q3soway">
              <Link to={`/createurs/${c.id}`} className="group grid grid-cols-[96px_1fr_auto] items-center gap-4 py-5 md:grid-cols-[130px_1fr_auto]" data-id="element-360" data-mp="1xzejure9hqkd">
                <span className="font-display text-3xl md:text-4xl" data-id="element-361" data-mp="27s3g4f18qxv4">{formatDate(c.exhibitionStart, 'd MMM')}</span>
                <span className="min-w-0" data-id="element-362" data-mp="1k298cbvs3zhq">
                  <span className="block font-medium transition-colors duration-150 group-hover:text-clay" data-id="element-363" data-mp="1f2efi2sg0zu1">{c.name}</span>
                  <span className="block truncate text-sm text-muted" data-id="element-364" data-mp="1u06umtu2vm7p">
                    {c.craft} · {c.city}
                  </span>
                </span>
                <span className="text-xs text-muted" data-id="element-365" data-mp="1p2nfzstgx7f8">dans {daysUntilStart(c)} j</span>
              </Link>
            </li>)}
        </ul>
      </div>
    </section>;
}